import { LIBERTY_ROLES } from '@/constants/roles'
import type { UserData } from '@/types/auth'

/**
 * Angular `authService.getSelectedCurrentUserRole()` reads `current_role` from the
 * persisted `localStorage.user`, so the Messages tab stays visible on a hard refresh
 * before the Redux user has hydrated.
 */
function storedRoleName(): string {
  try {
    const raw = localStorage.getItem('user')
    if (!raw) return ''
    return (JSON.parse(raw) as UserData).current_role?.role_name ?? ''
  } catch {
    return ''
  }
}

/** Angular profile.component: Messages tab is shown for Liberty roles only. */
export function canViewProfileMessages(roleName: string): boolean {
  const resolved = roleName || storedRoleName()
  return (LIBERTY_ROLES as readonly string[]).includes(resolved)
}
